import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import cookie from "../func/Cookie";
import { connect } from 'react-redux';
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        return (
            <div>
                <nav className="navbar navbar-light navbar-fixed-top" style={{ "backgroundColor": "#e3f2fd" }} >
                    <div className="container-fluid">
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <div >
                                <Link to="/"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'root' ? 'green' : '', 'marginLeft': '10px' }}>  انبار</button></Link>
                                <Link to="/newrequest"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'newrequest' ? 'green' : '', 'marginLeft': '10px' }} >ثبت سفارش</button></Link>
                                <Link to="/pishfactors"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'pishfactors' ? 'green' : '','marginLeft': '10px' }} > سفارش ها</button></Link>
                                <Link to="/confirmfactors"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'confirmfactors' ? 'green' : '', 'marginLeft': '10px' }} >   حواله های خروج </button></Link>
                                <Link to="/reports"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'reports' ? 'green' : '', 'marginLeft': '10px' }} >    گزارشات  </button></Link>
                                <Link to="/reportkala"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'reportkala' ? 'green' : '', 'marginLeft': '10px' }} >   گزارش گردش کالا  </button></Link>
                                <Link to="/increquest"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'increquest' ? 'green' : '', 'marginLeft': '10px' }}>ورودی به انبار </button></Link>
                            </div>
                        </div>
                        {//<Link to="/about"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": "#e3f2fd", 'marginLeft': '10px' }}>درباره </button></Link>
                        }
                        {(cookie.get("user") != "admin") ? null :
                            <div>
                                <React.Fragment>
                                    <Link to="/kala"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'kala' ? 'green' : '', 'marginLeft': '10px' }}> تعریف کالا </button></Link>
                                    <Link to="/useraccess"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'useraccess' ? 'green' : '', 'marginLeft': '10px' }}> مدیریت کاربری </button></Link>
                                    <Link to="/backup"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'backup' ? 'green' : '', 'marginLeft': '10px' }}>  پشتیبان گیری </button></Link>
                                    {/* <Link to="/about"><button className="btn btn-outline-success" type="button" style={{ "backgroundColor": this.props.color == 'root' ? 'green' : '', 'marginLeft': '10px' }}>  About </button></Link> */}
                                </React.Fragment>
                            </div>
                        }
                    </div>
                </nav>
            </div >
        );
    }
}
const mapStateToProps = state => {
    return {
        color: state
    };
};
export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/layout/Header.js